// removed by extract-text-webpack-plugin
module.exports = {"loadingbar":"loadingbar__2Tp79","wrapper":"wrapper__C5ohQ","text":"text__2q1DK","bar":"bar__1GcCX"};


//////////////////
// WEBPACK FOOTER
// ./components/loadingbar/scss/loadingbar.scss
// module id = awuE
// module chunks = 0